var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72879 3.95349L3.18804 11.4842C3.22366 12.0604 3.7113 12.5238 4.3196 12.5238H9.43132C10.0267 12.5238 10.5095 12.0795 10.5617 11.5176L11.2537 3.95237C9.98748 3.87139 8.29999 3.78249 6.99999 3.78249C5.69401 3.78249 3.99696 3.87221 2.72879 3.95349ZM12.3942 4.03037C12.5175 4.03936 12.6261 4.04746 12.7176 4.05439C12.8236 4.06241 12.9066 4.06887 12.9631 4.07331L13.0487 4.08012C13.3632 4.10566 13.6392 3.87139 13.6648 3.55684C13.6903 3.24228 13.456 2.96657 13.1415 2.94103L13.0527 2.93397C12.9952 2.92945 12.9111 2.92291 12.8039 2.91479C12.5897 2.89857 12.2836 2.87605 11.9152 2.85082C10.6261 2.76254 8.55505 2.63963 6.99999 2.63963C5.44493 2.63963 3.37384 2.76254 2.08478 2.85082C1.71642 2.87605 1.41027 2.89857 1.19605 2.91479C1.08894 2.92291 1.00478 2.92945 0.947291 2.93397L0.858969 2.94099C0.544415 2.96654 0.309686 3.24228 0.33523 3.55684C0.360775 3.87139 0.636477 4.10568 0.951029 4.08014M0.951029 4.08014L1.0369 4.07331C1.09336 4.06887 1.17641 4.06241 1.28236 4.05439C1.36961 4.04778 1.47238 4.04011 1.58858 4.03163L2.04733 11.5542C2.12099 12.7486 3.12304 13.6667 4.3196 13.6667H9.43132C10.6012 13.6667 11.5919 12.7882 11.6997 11.6224L12.3942 4.03037",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93333 1.4762C5.82813 1.4762 5.74286 1.56148 5.74286 1.66668V2.88161C5.74286 3.1972 5.48702 3.45304 5.17143 3.45304C4.85584 3.45304 4.6 3.1972 4.6 2.88161V1.66668C4.6 0.930297 5.19696 0.333344 5.93333 0.333344H8.06666C8.80303 0.333344 9.39998 0.930299 9.39998 1.66668V2.88161C9.39998 3.1972 9.14415 3.45304 8.82856 3.45304C8.51297 3.45304 8.25713 3.1972 8.25713 2.88161V1.66668C8.25713 1.56148 8.17185 1.4762 8.06666 1.4762H5.93333Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99052 2.88162C3.99052 2.56603 4.24636 2.31019 4.56195 2.31019L5.78099 2.31019C6.09658 2.31019 6.35241 2.56603 6.35241 2.88162C6.35241 3.19722 6.09658 3.45305 5.78099 3.45305H4.56195C4.24636 3.45305 3.99052 3.19722 3.99052 2.88162Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64759 2.88162C7.64759 2.56603 7.90343 2.31019 8.21902 2.31019H9.43806C9.75365 2.31019 10.0095 2.56603 10.0095 2.88162C10.0095 3.19722 9.75365 3.45305 9.43806 3.45305H8.21902C7.90343 3.45305 7.64759 3.19722 7.64759 2.88162Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99999 5.60493C7.31558 5.60493 7.57142 5.86077 7.57142 6.17636V10.13C7.57142 10.4456 7.31558 10.7015 6.99999 10.7015C6.6844 10.7015 6.42857 10.4456 6.42857 10.13V6.17636C6.42857 5.86077 6.6844 5.60493 6.99999 5.60493Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56195 6.26385C4.87754 6.26385 5.13337 6.51969 5.13337 6.83528V9.47106C5.13337 9.78665 4.87754 10.0425 4.56195 10.0425C4.24636 10.0425 3.99052 9.78666 3.99052 9.47106V6.83528C3.99052 6.51969 4.24636 6.26385 4.56195 6.26385Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43804 6.26385C9.75363 6.26385 10.0095 6.51969 10.0095 6.83528V9.47106C10.0095 9.78665 9.75363 10.0425 9.43804 10.0425C9.12245 10.0425 8.86662 9.78666 8.86662 9.47106V6.83528C8.86662 6.51969 9.12245 6.26385 9.43804 6.26385Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGray);
export default __webpack_public_path__ + "static/media/delete-gray.7fe84313.svg";
export { ForwardRef as ReactComponent };